<style lang="less">
.wx-mainpage{
    position:relative;
    overflow-y: auto;
    width:100%;
    height:100%;
    padding:15px;
    .page-wrap{
        clear:both;
    }
}
</style>
<template lang="html">
	<div class="wx-mainpage">
        <slot></slot>
	</div>
</template>

<script>

// import pageMaxin from '@components/mixins/page.js';

export default {
	// mixins: [pageMaxin],
    data:function(){
        return {
        }
    },
    components: {

    },
    mounted(){
		
	},
	computed:{
		
	},
	methods: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Mainpage.vue